import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, forkJoin, from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { TabService } from '../services/tabs/tab.service';
import { CoreResolver } from './core.resolver';
import { StorefrontListResolver } from './storefront-list.resolver';
import { KEYS } from '../utils/constants/storage.constants';

@Injectable()
export class StorefrontCombinedResolver implements Resolve<any> {
  constructor(
    private readonly storefrontListResolver: StorefrontListResolver,
    private readonly coreResolver: CoreResolver,
    private readonly tabService: TabService,
    private readonly localStorage: LocalStorageService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const runInSequence = this.localStorage.getItem(KEYS.FRESH_LAUNCH);
    if (runInSequence === 'true') {
      this.tabService.cleanUp();
      return from(this.coreResolver.resolve(route)).pipe(
        switchMap(() => this.storefrontListResolver.resolve(route))
      );
    } else {
      return forkJoin({
        coreData: this.coreResolver.resolve(route),
        storefrontData: this.storefrontListResolver.resolve(route),
      }).pipe(map((result) => result.storefrontData));
    }
  }
}
